var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplayIcon = function SvgReplayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.434 2.978A9.166 9.166 0 0 0 4.532 4.503L1.833 7.039V3.66a.917.917 0 1 0-1.833 0v5.5c0 .506.41.916.917.916h5.5a.917.917 0 1 0 0-1.833H3.23L5.798 5.83l.02-.02a7.333 7.333 0 1 1-1.736 7.627.917.917 0 0 0-1.73.61 9.167 9.167 0 1 0 13.082-11.07"
  })));
};
export default SvgReplayIcon;